import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SpecialInsuranceCaseDTO  {
    _originalTypeClassName = "zERP.BO.SpecialInsuranceCaseDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SpecialInsuranceCaseDTO.translate = translateService;
}
this.Id = null;
this.Code = null;
this.Name = null;
this.SpecialInsuranceCaseDTOKey = null;
this._key = this.SpecialInsuranceCaseDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Code:any;
Name:any;
private _SpecialInsuranceCaseDTOKey:any;
get SpecialInsuranceCaseDTOKey(): any {
    return this._SpecialInsuranceCaseDTOKey;
  }
set SpecialInsuranceCaseDTOKey(value: any) {
    this._SpecialInsuranceCaseDTOKey = value;
    this._key = value;
  }

static Assign(sic: any): any{let sicDTO = new Domain.SpecialInsuranceCaseDTO();
sicDTO.Id = sic?.Id;
sicDTO.Code = sic?.Code;
sicDTO.Name = sic?.Name;
return sicDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SpecialInsuranceCaseDTOKey == null || $this.SpecialInsuranceCaseDTOKey == 0;
            }


}